import { Injectable } from '@angular/core';
import { UserRoles } from '@shared/constants/user-roles.constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../oauth-service/user.service';

@Injectable({
  providedIn: 'root',
})
export class OplExtService {
  constructor(private userService: UserService) {}

  /**
   * Checks if the current user has the SMARTPORTAL_OPL_EXT role
   * @returns Observable<boolean> indicating whether the user has OPL_EXT role
   */
  checkIsOplExt(): Observable<boolean> {
    return this.userService
      .checkIfUserHasRole(UserRoles.SMARTPORTAL_OPL_EXT)
      .pipe(map(hasRole => hasRole));
  }
}
